import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function PlanFrance2030Page() {
  const aide = getAideAgricoleStub('plan-france-2030');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
